import { MCP_SCOPE_PREFIX } from './constants';
import type { ConsentScope } from './types';

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const letters =
    (parts[0]?.[0] ?? '') + (parts[1]?.[0] ?? parts[0]?.[1] ?? '');

  return letters.toUpperCase() || '?';
}

// MCP scopes are represented by the access-level tiers; the remaining
// (identity) scopes are still granted and must stay visible next to them.
export function nonMcpScopes(scopes: ConsentScope[]): ConsentScope[] {
  return scopes.filter(scope => !scope.scope.startsWith(MCP_SCOPE_PREFIX));
}
